import Vue from 'vue'
import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false

new Vue({
  i18n,
  el: '#app',
  router,
  store,


  data: {
    paypal: {
      sandbox: '<sandbox client id>',
      production: '<production client id>'
    }
  },
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js